import Vue from "vue";
import VueRouter from "vue-router";
import MainLayout from "@/components/common/MainLayout";
import AdminLayout from "@/components/common/AdminLayout";
import store from "@/store/";
import { getToken, getSimpleUserInfo } from "@/utill/auth";
import { fn_postSubmit } from "@/utill/commom";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const PatientDashboard = "/patientCare/patientInquiry/patientDashboard";
const Prescription =
  "/patientCare/patientInquiry/patientDashboard/prescription";
const AddRemedy = "/remedyManagement/remedyInquiry/addRemedy";
const AdminFileManagement = "/admin/fileManagement";
const AdminFuncManagement = "/admin/funcManagement";
const PrescriptionTemAddOrEdit = "/patientCare/prescriptionTemplate/addOrEdit";
const FaqManagement = "/community/faqManagement";
const QnaManagement = "/community/qnaManagement";
const UnansweredConsultation = "/statistical/unansweredConsult";
const DiagnosticResults = "/statistical/diagnosticResults";
const CongnitiveBehavior = "/statistical/congnitiveBehavior";
const UsageTime = "/statistical/usageTime";
const whiteList = [
  "/login",
  PatientDashboard,
  Prescription,
  AddRemedy,
  AdminFileManagement,
  AdminFuncManagement,
  FaqManagement,
  QnaManagement,
  PrescriptionTemAddOrEdit,
  UnansweredConsultation,
  DiagnosticResults,
  CongnitiveBehavior,
  UsageTime,
]; // no redirect whitelist

const routes = [
  {
    path: "/",
    component: MainLayout,
    redirect: "/dashboard/astop",
    children: [
      {
        path: "/dashboard/astop",
        name: "AstopDashBoard",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/Dashboard/AstopDashBoard.vue"
          ),
        beforeEnter(to, from, next) {
          next();
        },
      },
      {
        path: "/dashboard/mstrong",
        name: "MstrongDashBoard",
        component: () => import("@/views/Dashboard/MstrongDashBoard.vue"),
      },
      {
        path: "/patientCare/patientInquiry",
        name: "PatientInquiry",
        component: () => import("@/views/Patient/Patient/PatientInquiry.vue"),
      },
      {
        path: "/patientCare/prescriptionTemplate",
        name: "PrescriptionTemplate",
        component: () =>
          import(
            "@/views/Patient/PrescriptionTemplate/PrescriptionTemplate.vue"
          ),
      },
      {
        path: "/patientCare/prescriptionTemplate/addOrEdit",
        name: "PrescriptionTemAddOrEdit",
        component: () =>
          import("@/views/Patient/PrescriptionTemplate/AddOrEdit.vue"),
      },
      {
        path: "/patientCare/patientInquiry/patientDashboard/prescription",
        name: "Prescription",
        component: () => import("@/views/Patient/Patient/Prescription.vue"),
      },
      {
        path: "/patientCare/patientInquiry/patientDashboard",
        name: "PatientDashboard",
        component: () => import("@/views/Patient/Patient/PatientDashboard.vue"),
      },
      {
        path: "/remedyManagement/remedyInquiry",
        name: "RemedyManagement",
        component: () => import("@/views/Remedy/RemedyInquiry.vue"),
      },
      {
        path: "/remedyManagement/remedyCategory", // @Deprecated
        name: "Remedy",
        component: () => import("@/views/Deprecated/RemedyCategory.vue"),
      },
      {
        path: "/remedyManagement/remedyInquiry/addRemedy",
        name: "AddTreatment",
        component: () => import("@/views/Remedy/AddRemedy.vue"),
      },
      {
        path: "/medicineManagement/medicineInquiry",
        name: "Medicine",
        component: () => import("@/views/Medicine/MedicineInquiry.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/medicineManagement/medicineCategory", // @Deprecated
        name: "MedicineCategory",
        component: () => import("@/views/Deprecated/MedicineCategory.vue"),
      },
      {
        path: "/systemManagement/permissionManagement",
        name: "SystemManagement",
        component: () =>
          import("@/views/SystemManagement/PermissionManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/systemManagement/commonCodeManagement",
        name: "CommonCodeManagement",
        component: () =>
          import("@/views/SystemManagement/CommonCodeManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/systemManagement/functionManagement",
        name: "FunctionManagement",
        component: () =>
          import("@/views/SystemManagement/FunctionManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/systemManagement/userManagement",
        name: "UserManagement",
        component: () => import("@/views/SystemManagement/UserManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/systemManagement/agencyManagement",
        name: "AgencyManagement",
        component: () =>
          import("@/views/SystemManagement/AgencyManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/systemManagement/menuManagement",
        name: "MenuManagement",
        component: () => import("@/views/SystemManagement/MenuManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/systemManagement/appVersionManagement",
        name: "AppVersionManagement",
        component: () =>
          import(
            /* webpackChunkName: "appVersionManagement" */ "@/views/SystemManagement/AppVersionManagement"
          ),
        meta: { requiresAuth: true },
      },
      {
        path: "/systemManagement/appLogInquiry",
        name: "AppLogInquiry",
        component: () => import("@/views/SystemManagement/AppLogInquiry.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/community/faqManagement",
        name: "FaqManagement",
        component: () => import("@/views/Community/FaqManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/community/qnaManagement",
        name: "QnaManagement",
        component: () => import("@/views/Community/QnaManagement.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/statistical/unansweredConsult",
        name: "UnansweredConsultation",
        component: () =>
          import("@/views/Statistical/UnansweredConsultation.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/statistical/diagnosticResults",
        name: "DiagnosticResults",
        component: () => import("@/views/Statistical/DiagnosticResults.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/statistical/congnitiveBehavior",
        name: "CongnitiveBehavior",
        component: () => import("@/views/Statistical/CongnitiveBehavior.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/statistical/usageTime",
        name: "UsageTime",
        component: () => import("@/views/Statistical/UsageTime.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/common/MainLogin.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/error",
    name: "PermissionError",
    component: () => import("@/views/common/PermissionError.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/admin",
    component: AdminLayout,
    redirect: "/admin/fileManagement",
    children: [
      {
        path: "/admin/fileManagement",
        name: "FileManagement",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/Admin/FileManagement.vue"
          ),
        beforeEnter(to, from, next) {
          next();
        },
      },
      {
        path: "/admin/funcManagement",
        name: "FuncManagement",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/Admin/FuncManagement.vue"
          ),
        beforeEnter(to, from, next) {
          next();
        },
      },
    ],
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log(`router => to: ${to.path}`);

  if (to.path.indexOf("http") > -1) {
    /* let position = to.fullPath.indexOf("http");
             let externalLink = to.fullPath.substring(position, to.fullPath.length);
             console.log(`external link:` + externalLink);
             window.open(
               externalLink,
               "newwindow",
               "height=200,width=400,top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no"
             );
             return;*/
    const baseLink = store.getters.getUserMenuTree[0].subMenu[2].link;

    const simpleUserInfo = JSON.parse(getSimpleUserInfo());
    const params = {
      mid: "patient",
      accessKey: simpleUserInfo.accessToken,
      loginId: simpleUserInfo.userId,
      loginName: simpleUserInfo.name,
      patientNumber: null,
    };
    fn_postSubmit(baseLink, params);

    return;
  }
  const hasToken = getToken();
  if (hasToken) {
    const simpleUserInfo = JSON.parse(getSimpleUserInfo());

    if (to.path === "/login") {
      next({ path: "/" });
    } else if (to.path === "/error") {
      next();
    } else {
      let hasRole = false;
      if (simpleUserInfo) {
        hasRole = simpleUserInfo.roleId ? true : false;
      }
      if (hasRole) {
        hasPermission(to.path, simpleUserInfo.roleId).then((isAccessible) => {
          if (isAccessible) {
            next();
          } else {
            if (
              simpleUserInfo.roleId === "ROLE013" ||
              simpleUserInfo.roleId === "ROLE015"
            ) {
              next(`/dashboard/mstrong`);
            } else if (
              simpleUserInfo.roleId === "ROLE012" ||
              simpleUserInfo.roleId === "ROLE014"
            ) {
              next(`/dashboard/astop`);
            } else {
              next(`/error?redirect=${to.path}`);
            }
          }
        });
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          console.log(`try to get user role`);
          await store.dispatch("getUserInfo");

          // generate accessible routes map based on roles
          /*const accessRoutes = await store.dispatch(
                                "permission/generateRoutes",
                                roles
                              );
                    
                              // dynamically add accessible routes
                              router.addRoutes(accessRoutes);*/

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("resetToken");
          next(`/login?redirect=${to.path}`);
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
    }
  }
});

async function hasPermission(link, roleId) {
  // 임시 - 시스템 관리자인 경우 모든 페이지 접속가능
  // if (roleId === "ROLE001" || roleId === "ROLE004") return true;
  let result = false;
  console.log(`hasPermission => page: ${link}, role: ${roleId}`);
  //if (roleId != "") return true;
  //let allMenus = store.state.systemManagement.menuManagement;
  if (whiteList.indexOf(link) !== -1) {
    result = true;
  } else {
    await store.dispatch("createUserMenu").then((userMenus) => {
      // 링크에 해당하는 메뉴 찾기
      let matchedMenus = userMenus.filter((menu) => {
        //return menu.link.toLowerCase().split("/")[2] === pageName.toLowerCase();
        return menu.link === link;
      });
      if (matchedMenus.length > 0) {
        result = true;
      } else {
        result = false;
      }
    });
  }
  return result;
  /*
      // 메뉴에 매칭된 기능이 현재 사용자 소유한 기능들에 포함여부
      store.dispatch("getUserFunctions").then((userFunctions) => {
        let matchedFuncs = userFunctions.filter((func) => {
          func.funcId === matchedMenus[0].funcId;
        });
        if (matchedFuncs.length > 0) {
          return true;
        } else {
          return false;
        }
      });*/
}

// eslint-disable-next-line no-unused-vars
function hasPermission_bak(pageName, roleId) {
  let roles = getRoleByPageName(pageName);
  if (roles.length > 0) {
    return roles.includes(roleId);
  } else {
    return false;
  }
}

function getRoleByPageName(pageName) {
  if (pageName === "Dashboard") {
    // get role list by this page from API server.
    return ["ROLE001", "ROLE002", "ROLE003", "ROLE004"];
  } else {
    return [];
  }
}

export default router;

// title, favicon 변경 테스트

router.afterEach(() => {
  // window.location.host
  const host = window.location.host;
  const hostArr = host.split(".");
  const location = hostArr[0];
  Vue.nextTick(() => {
    // 사용자 권한에 따라 title 및 favicon 변경

    if (location === "mindstrong") {
      document.title =
        "MIND STRONG 의료진용 디지털치료기기 플랫폼 (Digital Therapeutics Platform)";
      document.querySelector("#favicon").setAttribute("href", "/mfavicon.ico");
    } else {
      document.title =
        "A-STOP 의료진용 디지털치료기기 플랫폼 (Digital Therapeutics Platform)";
      document.querySelector("#favicon").setAttribute("href", "/afavicon.ico");
    }
  });
});
